export {
  isSomeElementSelected,
  getElementsWithinSelection,
  getSelectedElements,
  getTargetElements,
} from "@excalidraw/element";
export { calculateScrollCenter } from "./scroll";
export {
  hasBackground,
  hasStrokeWidth,
  hasStrokeStyle,
  canHaveArrowheads,
  canChangeRoundness,
} from "@excalidraw/element";
export {
  getNormalizedZoom,
  getNormalizedGridSize,
  getNormalizedGridStep,
} from "./normalize";
